import { useEffect, useState } from 'react'

export function useHLNames(address?: string | null): { name: string | null; loading: boolean } {
  const [name, setName] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    async function fetchName() {
      if (!address) {
        setName(null)
        return
      }

      setLoading(true)
      try {
        const response = await fetch(`https://api.hlnames.xyz/resolve/primary_name/${address}`, {
          headers: {
            'X-API-Key': 'CPEPKMI-HUSUX6I-SE2DHEA-YYWFG5Y',
          },
        })

        if (response.ok) {
          const data = await response.json()
          setName(data?.primaryName !== '' && data?.primaryName ? data?.primaryName : null)
        } else {
          setName(null)
        }
      } catch (error) {
        console.warn('Error fetching HLNames:', error)
        setName(null)
      } finally {
        setLoading(false)
      }
    }

    fetchName()
  }, [address])

  return { name, loading }
}
